// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"145e9a11","169":"1de19ca2","250":"d9f4735b","453":"822bd1c5"}[chunkId] + ".chunk.js";
};